/** @jsx jsx */

import React, {
  useContext,
  useState,
  useRef,
  useLayoutEffect,
  Fragment,
  useEffect,
} from 'react';
import { css, jsx } from '@emotion/core';
import { colors, getButtonFocus } from 'styles/variables';
import { interactionContext as _interactionContext } from './interactionContext';
import {
  MultichoiceImageContext,
  TMultichoiceImageContextValue,
} from './MultichoiceImage';

const { lPink, lGrey0, lTeal0 } = colors;

const Tick = ({ background, color }) => {
  return (
    <div
      style={{
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        right: -22,
        top: -22,
        width: 44,
        height: 44,

        background: '#fff',
        borderRadius: '50%',
        border: `1px solid ${background}`,
      }}
    >
      <svg
        width="16px"
        height="15px"
        viewBox="0 0 16 15"
        version="1.1"
        aria-describedby="title"
      >
        <title>Correct</title>
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <polyline
            id="Path"
            stroke={color}
            strokeWidth="2"
            transform="translate(7.486953, 6.527846) rotate(6.000000) translate(-7.486953, -6.527846) "
            points="0.886953048 9.1308343 6.78684502 13.1278461 14.086953 -0.0721539421"
          />
        </g>
      </svg>
    </div>
  );
};

const Answer = props => {
  const interactionContext = useContext(_interactionContext);
  // console.log(interactionContext);
  //
  const {
    imageWidth = 130,
    imageHeight = 130,
    correctOptions,
    focusColor = lTeal0,
    selectedColor = lPink,
    imageBorderRadius = 5,
    imageBackground = '#fff',
    showCorrectAnswer = true,
  } = interactionContext.props;

  const multichoiceImageContext = useContext(
    MultichoiceImageContext
  ) as TMultichoiceImageContextValue;
  const { selected, setSelected, isLive, isResolved } = multichoiceImageContext;

  const { index, children } = props;

  const [hasFocus, setHasFocus] = useState<boolean>(false);
  const isSelected = selected.includes(index);
  const isCorrectOption = correctOptions.includes(index);
  const [img, txt] = children;

  let boxShadow = 'none';

  if (hasFocus) {
    boxShadow = getButtonFocus(focusColor).replace(/box-shadow: /, '');
  }

  if (isSelected) {
    boxShadow = getButtonFocus(selectedColor).replace(/box-shadow: /, '');
  }

  if (window.dev() && correctOptions.includes(index)) {
    boxShadow = `0 0 0 3px ${lPink}`;
  }

  return (
    <button
      type="button"
      css={css({
        // border: 'none',
        // outline: 'none',
        all: 'unset',
        margin: 20,
        cursor: 'pointer',

        pointerEvents: isResolved ? 'none' : 'auto',
      })}
      onClick={e => {
        setSelected(index);
      }}
      onFocus={() => {
        // give image focus
        setHasFocus(true);
      }}
      onBlur={() => {
        // give image focus
        setHasFocus(false);
      }}
      disabled={isResolved}
      aria-disabled={isResolved}
    >
      <div
        css={css({
          position: 'relative',
          width: imageWidth,
          height: imageHeight,

          // // boxShadow: `0 0 0 2px ${isSelected ? focusColor : 'transparent'}`,
          // boxShadow: hasFocus
          //   ? getButtonFocus(focusColor).replace(/box-shadow: /, '')
          //   : 'none',

          // ...(window.dev() && {
          //   boxShadow: `0 0 0 2px ${
          //     correctOptions.includes(index) ? 'red' : 'transparent'
          //   }`,
          // }),
          boxShadow,
          borderRadius: imageBorderRadius,
          transition: 'box-shadow 0.2s',
          background: imageBackground,
        })}
      >
        {img}

        {showCorrectAnswer && isResolved && isCorrectOption && (
          <Tick background={imageBackground} color={selectedColor} />
        )}
      </div>
      <div
        style={{
          margin: '5px 0 0 0',
          textAlign: 'center',
        }}
      >
        {txt}
      </div>
    </button>
  );
};

export default Answer;
